import { createColorArray } from '../../utils/colors';
import { displayPercent, displayShortDate } from '../../utils/Format/Format';

const getData = (allocationData, allocationPercentField) => {
    const colors = createColorArray(allocationData.length);

    const chartData = allocationData.map((ele, i) => ({
        label: ele.name,
        value: ele[allocationPercentField],
        color: colors[i]
    }));

    chartData.sort((a, b) => b.value - a.value);

    return {
        chartData,
        data: chartData.map((e) => ({
            ...e,
            value: displayPercent(e.value)
        }))
    };
};

export const sectorAllocationUtil = (gqlResult) => {
    if (!gqlResult) return null;

    const {
        correspondingFundTicker,
        inceptionDate,
        diversificationRankings
    } = gqlResult.fund;

    const rawDiversificationData = diversificationRankings || [];

    const { asOfDate } =
        rawDiversificationData.find((ele) => ele.asOfDate) || {};
    const { data, chartData } = getData(
        rawDiversificationData,
        'percentTotalNetAssets'
    );

    return {
        data,
        correspondingFundTicker,
        chartData,
        inceptionDate,
        asOfDate: asOfDate && displayShortDate(asOfDate)
    };
};

export const sectorAllocationUtilETF = (gqlResult) => {
    if (!gqlResult) return null;

    const { inceptionDate, sectorAllocation } = gqlResult.fund;

    const sectorAllcationData = sectorAllocation || {};
    const { asOfDate, oneMonthAllocation } = sectorAllcationData;
    const { fundAllocationData = [] } = oneMonthAllocation || {};

    const { data, chartData } = getData(
        fundAllocationData,
        'allocationPercent'
    );

    const hasValues = fundAllocationData.some((dt) =>
        Boolean(dt.allocationPercent)
    );

    return {
        data,
        inceptionDate,
        hasValues,
        chartData,
        asOfDate: asOfDate && displayShortDate(asOfDate)
    };
};
